module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "headerWrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "logoWrap"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript: void(0)"
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/saipa_logo.png"),
      "width": "58",
      "height": "74",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "loginNav"
    }
  }, [_c('label', {
    attrs: {
      "id": "userName"
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/nav_global.png"),
      "width": "18",
      "height": "18",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "language"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectLanguage()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "EN"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FAR"
    }
  }, [_vm._v("فارسي")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AR"
    }
  }, [_vm._v("العربية")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0417a59b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/layout/Header.vue
// module id = 103
// module chunks = 1